module.exports = __webpack_public_path__ + "static/logo-89bb6e6a4bcb54974c12b464cd8b5deb.png";